import * as React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Title from "../Title";
function preventDefault(event) {
    event.preventDefault();
}



export default function Overview({revenueThisMonth,revenueLastMonth}) {


    const format = (value) => {
        const valueFormatted = '$' + value.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        return `${valueFormatted}`;
    }

    return (
        <React.Fragment>
            <Title>Overview Revenue</Title>
            <Typography component="p" variant="h4">
                {format(revenueThisMonth)}
            </Typography>
            <Typography color="text.secondary" sx={{ flex: 1 }}>
                this month
            </Typography>
            <Typography component="p" variant="h4">
                {format(revenueLastMonth)}
            </Typography>
            <Typography color="text.secondary" sx={{ flex: 1 }}>
                last month
            </Typography>

        </React.Fragment>
    );
}